import { MutationCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { toast } from "sonner";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider, RequireAuth } from "@/lib/auth";
import { AuditLog } from "@/pages/AuditLog";
import { ImagePulls } from "@/pages/ImagePulls";
import { Login } from "@/pages/Login";
import { Machines } from "@/pages/Machines";
import { Profiles } from "@/pages/Profiles";
import { Releases } from "@/pages/Releases";
import { ServiceDetail } from "@/pages/ServiceDetail";
import { Services } from "@/pages/Services";

const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error) => {
      toast.error("Action failed", {
        description: error instanceof Error ? error.message : "Something went wrong",
      });
    },
  }),
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <AuthProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/machines"
                element={
                  <RequireAuth>
                    <Layout>
                      <Machines />
                    </Layout>
                  </RequireAuth>
                }
              />
              <Route
                path="/releases"
                element={
                  <RequireAuth>
                    <Layout>
                      <Releases />
                    </Layout>
                  </RequireAuth>
                }
              />
              <Route
                path="/profiles"
                element={
                  <RequireAuth>
                    <Layout>
                      <Profiles />
                    </Layout>
                  </RequireAuth>
                }
              />
              <Route
                path="/services"
                element={
                  <RequireAuth>
                    <Layout>
                      <Services />
                    </Layout>
                  </RequireAuth>
                }
              />
              <Route
                path="/services/:slug"
                element={
                  <RequireAuth>
                    <Layout>
                      <ServiceDetail />
                    </Layout>
                  </RequireAuth>
                }
              />
              <Route
                path="/audit"
                element={
                  <RequireAuth>
                    <Layout>
                      <AuditLog />
                    </Layout>
                  </RequireAuth>
                }
              />
              <Route
                path="/image-pulls"
                element={
                  <RequireAuth>
                    <Layout>
                      <ImagePulls />
                    </Layout>
                  </RequireAuth>
                }
              />
              <Route path="*" element={<Navigate to="/machines" replace />} />
            </Routes>
          </Router>
        </AuthProvider>
      </TooltipProvider>
    </QueryClientProvider>
  );
}
